import { Download } from 'lucide-react';
import LegalPageShell from '@/components/legal/LegalPageShell';
import TermsConditionsContent from './TermsConditionsContent';
import { legalAssets } from '@/config/legal';

export default function TermsConditionsPage() {
  return (
    <LegalPageShell
      title="Sync360 Terms of Use"
      subtitle="Last Modified: October 15, 2025"
      showTermsLink={false}
    >
      <div className="mb-8 flex flex-wrap items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
        <p className="text-sm text-gray-600">
          You can also download the full terms document as a PDF.
        </p>
        <a
          href={legalAssets.termsConditionsPdf}
          download
          className="inline-flex items-center gap-2 px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors text-sm font-medium"
        >
          <Download className="h-4 w-4" />
          Download PDF
        </a>
      </div>

      <TermsConditionsContent />
    </LegalPageShell>
  );
}
